import { render, staticRenderFns } from "./CoinCampaigns.vue?vue&type=template&id=35ab66a9&scoped=true"
import script from "./CoinCampaigns.vue?vue&type=script&lang=js"
export * from "./CoinCampaigns.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=35ab66a9&prod&scoped=true&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/styles/multiselect.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./CoinCampaigns.vue?vue&type=style&index=3&id=35ab66a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab66a9",
  null
  
)

export default component.exports